<template>
  <div>
    <v-card flat class="mt-5">
      <h5>Maskinslag</h5>
      <v-data-table
        :headers="[
          {
            text: 'Maskin',
            sortable: false,
            filterable: false,
            value: 'machine',
            width: '340',
          },
          {
            text: 'Utfärdat',
            sortable: false,
            filterable: false,
            value: 'createdAt',
            width: '120',
          },
          { text: 'Utfärdare', filterable: false, value: 'issuedById', width: '170' },
          {
            text: 'STATUS',
            sortable: false,
            filterable: false,
            value: 'state',
            width: '160',
          },
          { text: '', filterable: false, value: 'actions' },
        ]"
        :items="MQs"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
      >
        <template slot="item.machine" slot-scope="props">{{
          props.item.machine.name
        }}</template>
        <template slot="item.createdAt" slot-scope="props">{{
          props.item.createdAt | date
        }}</template>
        <template slot="item.issuedById" slot-scope="props"
          >{{ get(props, 'item.issuedBy.firstName', '-') }}
          {{ get(props, 'item.issuedBy.lastName', '-') }}</template
        >
        <template slot="item.state" slot-scope="props">
          
          <template v-if="!props.item.approvedOn">
            <span v-if="userCanApprove(props.item) || !props.item.issuedById" class="small">
              Väntar på godk.
            </span>
            <span v-else class="small">
              Väntar på godkännande av annan regionär.
            </span>
          </template>

          <span v-else class="small"> Godkänd. </span>
        </template>
        <template slot="item.actions" slot-scope="props">
          <div class="d-flex justify-end">
            <v-btn
              v-if="userCanApprove(props.item) && !props.item.approvedOn"
              class="ml-2"
              :disabled="hasTradeCertificateId(props.item) || !canApprove"
              @click="
                mqMode = 'approve';
                mqModalObj = props.item;
                mqModal = true;
              "
            >
              <v-icon>$sl-like</v-icon>Godkänn
            </v-btn>
            <v-btn
              class="ml-4"
              color="secondary"
              @click="
                mqMode = 'show';
                mqModalObj = props.item;
                mqModal = true;
              "
            >
              Visa / Ändra
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="mqModal" :max-width="mqMode === 'copy' ? '900px' : '600px'">
        <PersonMachineQualificationModal
          @approve="approve"
          :mq="mqModalObj"
          @create="create"
          @close="mqModal = false"
          :mode="mqMode"
        />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import API from "@/services/api";
import { RulesMixin, UserRules, CanIDo } from "@/components/mixins";
import PersonMachineQualificationModal from "@/components/person/PersonMachineQualificationModal";
import { pageSize } from "@/store/constants";
import get from 'lodash/get'

// @group Person
// PersonMachineQualification component
export default {
  name: "PersonMachineQualification",
  mixins: [RulesMixin, UserRules, CanIDo],
  props: {
    initialMode: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    mqModal: false,
    mqMode: "",
    mqModalObj: {},
    itemsPerPage: pageSize,
  }),
  components: {
    PersonMachineQualificationModal,
  },
  watch: {
    initialMode(newValue) {
      if (this.initialMode == "Maskinslag") {
        this.mqMode = "create";
        this.mqModal = true;
      }
    },
  },
  computed: {
    ...mapGetters("person", ["selectedPerson"]),
    ...mapGetters("app", ["isLoading"]),
    ...mapGetters("currentuser", ["currentUser"]),
    ...mapGetters("basic", ["getProfessionNameById", "getRegionNameById", "activeMachines", "getMachineNameById"]),

    MQs() {
      if (this.selectedPerson.machinequalifications) {
        return this.selectedPerson.machinequalifications;
      } else {
        return [];
      }
    },
  },

  asyncComputed: {
    canApprove(){
      return this.canIDo('person-qualification', 'update');
    },
  },

  methods: {
    get,

    ...mapActions("person", ["setSelectedPerson"]),
    hasTradeCertificateId(item) {
      if (item && item.tradeCertificateId && item.tradeCertificateId > 0) return true;
      return false;
    },
    userCanApprove(item) {
      if (item && item.regionId && item.issuedById) {
        return this.canUserApprove(item.regionId, item.issuedById);
      }
      return false;
    },
    /**
     * @vuese
     * Used to create machine qualification
     * @arg The argument is object values representing machine qualification
     */
    async create(mq) {
      this.mqModal = false;
      mq.personId = this.selectedPerson.id;
      const res = await this.$dialog.confirm({
        text: `Intyg för maskinslag ${this.getMachineNameById(mq.machineId).toLowerCase()} till ${this.selectedPerson.firstName} ${this.selectedPerson.lastName}.`,
        title: "Vill du verkligen utfärda intyg för maskinslag?",
        width: '500px',        
        actions: [
          { text: "Avbryt", key: false, icon: "$sl-cancel", outlined: true },
          { text: "Utfärda", key: true, icon: "$sl-check" },
        ],
      });

      if (res !== true) return;
      API.createMachineCertification({ data: mq })
        .then((res) => {
          if (res && res.data && res.data.personId) {
            /**
             * @vuese
             * Used to fetch person
             * @arg The argument is integer values representing person id
             */
            API.getPerson(res.data.personId)
              .then((response) => {
                /**
                 * @vuese
                 * Used to update local store with the person data
                 * @arg the argument is an object representing person
                 */
                this.setSelectedPerson(response.data);
              })
              .catch((error) => {
                console.log("There was an error:", error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * @vuese
     * Used to approve machine qualification
     * @arg The argument is integer values representing person who approved
     */
    approve(mq) {
      this.mqModal = false;

      if (!this.userCanApprove(mq)) {
        this.$events.fire("showError", "Du kan inte godkänna detta utfärdande!");
        return;
      }

      API.approveMachinesQualification(mq.id)
        .then((res) => {
          mq.approvedBy = {};
          mq.approvedOn = new Date();
          mq.approvedById = this.currentUser.id;
          mq.approvedBy.id = this.currentUser.id;
          mq.approvedBy.firstName = this.currentUser.firstName;
          mq.approvedBy.lastName = this.currentUser.lastName;
          this.$events.fire("showInfo", "Sparad.");
          API.getPerson(this.selectedPerson.id)
            .then(response => {
              /**
               * @vuese
               * Used to update local store with the person data
               * @arg the argument is an object representing person
               */
              this.setSelectedPerson(response.data)
            })
            .catch(error => {
              console.log('There was an error:', error.response)
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
